import { EXPERT_STATUSES } from ".";

export default value => {
    const data = EXPERT_STATUSES.find(i => i.value === value);

    return data ? data.text : "N/A";
};
